<template>
    <div class="filters-wrapper">
        <div class="row">
            <!-- Lineas Multiselect -->
            <div id="lines" class="col-3">
                <label for="lines-multiselect">Líneas de producción</label>
                <b-form-select id="lines-multiselect" class="form-control chosen" multiple v-model="selectedProductionLine" :options="productionLinesOptions"></b-form-select>
            </div>
            <!-- Referencia -->
            <div class="col">
                <label for="reference-input">Artículo</label>
                <b-form-input id="reference-input" class="form-control" v-model="reference"></b-form-input>
            </div>
            <!-- Orden -->
            <div class="col">
                <label for="order-reference-input">Nº de pedido</label>
                <b-form-input id="order-reference-input" class="form-control" v-model="orderReference"></b-form-input>
            </div>
            <div class="col">
            <!-- Lote -->
                <label for="batch-input">Nº de lote</label>
                <b-form-input id="batch-input" class="form-control" v-model="batch"></b-form-input>
            </div>
            <div class="col">
            <!-- Cliente -->
                <label for="client-input">Cliente</label>
                <b-form-input id="client-input" class="form-control" v-model="client"></b-form-input>
            </div>
        </div>
        <div class="row">
            <div id="datepicker" class="col-3">
            <!-- Fecha Carga -->
                <label for="cargo-date-datepicker">Fecha de carga (desde)</label>
                <b-form-datepicker id="cargo-date-datepicker" v-model="cargoDate" reset-button label-reset-button="Resetear" today-button label-today-button="Seleccionar hoy" locale="es" placeholder="Seleccione fecha" ></b-form-datepicker>
            </div>
            <!-- Asc /Desc -->
            <b-form-radio-group id="radio-group" class="col-1">
                <b-form-radio v-model="order" value="asc" >Más antiguo</b-form-radio>
                <b-form-radio v-model="order" value="desc">Más nuevo</b-form-radio>
            </b-form-radio-group>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {FilterTypes} from "./FilterTypes";

export default {
    name: "Filters",
    mounted(){
        let self = this;
        $('.chosen').chosen()

        $('#lines_multiselect_chosen .chosen-choices').click(function(){
            self.addProductionLineListeners()
        })
        window.addProductionLineToFilter = self.addProductionLineToFilter
        if(this.filterByName(FilterTypes.PRODUCTION_LINES)?.length > 0){
            this.restartProductionLinesFilter();
        }
    },
    data(){
        return {
            selectedProductionLine:[],
        }
    },
    methods:{
        ...mapActions('production_control', ['updateFilter', 'deleteFilter']),
        // Production line Filter
        addProductionLineListeners(){
            if($('#lines_multiselect_chosen .chosen-results > li').length == this.productionLines.length){
                $('#lines_multiselect_chosen .chosen-results > li').attr('onclick','window.addProductionLineToFilter(this)' );
            }else setTimeout(this.addProductionLineListeners, 100)
        },
        restartProductionLinesFilter(){
            this.updateFilter({name:FilterTypes.PRODUCTION_LINES, value:[]})
        },
        addProductionLineToFilter(elem){
            let self = this;
            let productionLine = self.productionLines.find(pl => pl.name == $(elem).html() )

            let selectedProductionLines = self.filterByName(FilterTypes.PRODUCTION_LINES)??[]
            if(!selectedProductionLines.includes(productionLine.id)){
                selectedProductionLines.push(productionLine.id)
                this.updateFilter({name:FilterTypes.PRODUCTION_LINES, value:selectedProductionLines})

                $('#lines_multiselect_chosen .chosen-choices > .search-choice').each(function(){
                    if($(this).find('span').html() === productionLine.name)
                        $(this).find('.search-choice-close').click(function(){ self.removeProductionLineFromFilter(productionLine); })
                })
            }
        },
        removeProductionLineFromFilter(productionLine){
            let selectedProductionLines = this.filterByName(FilterTypes.PRODUCTION_LINES)??[]
            selectedProductionLines = selectedProductionLines.filter(pl => pl != productionLine.id)
            this.updateFilter({name:FilterTypes.PRODUCTION_LINES, value:selectedProductionLines})
        },
    },
    beforeDestroy(){
        this.restartFilters();
    },
    computed:{

        ...mapGetters(['productionLines']),
        ...mapGetters('production_control',['kanban', 'filters', 'filterByName']),
        productionLinesOptions(){
            return this.productionLines?.map(p => ({value: p.id, text: p.name}))
        },
        // Values
        selectedLines:{
            get: function(){
                return this.filterByName(FilterTypes.PRODUCTION_LINES);
            },
            set: function(selectedLines){
                this.updateFilter({name:FilterTypes.PRODUCTION_LINES, value:selectedLines})
            },
        },
        reference:{
            get: function(){
                return this.filterByName(FilterTypes.REFERENCES)
            },
            set: function(reference){
                this.updateFilter({name:FilterTypes.REFERENCES, value:reference})
            },
        },
        orderReference:{
            get: function(){
                return this.filterByName(FilterTypes.ORDER_REFERENCE)
            },
            set: function(orderReference){
                this.updateFilter({name:FilterTypes.ORDER_REFERENCE, value:orderReference})
            },
        },
        batch:{
            get: function(){
                return this.filterByName(FilterTypes.BATCH)
            },
            set: function(batch){
                this.updateFilter({name:FilterTypes.BATCH, value:batch})
            },
        },
        cargoDate:{
            get: function(){
                return this.filterByName(FilterTypes.CARGO_DATE)
            },
            set: function(cargoDate){
                this.updateFilter({name:FilterTypes.CARGO_DATE, value: cargoDate})
            },
        },
        order:{
            get: function(){
                return this.filterByName(FilterTypes.ORDER)
            },
            set: function(order){
                this.updateFilter({name:FilterTypes.ORDER, value: order})
            },
        },
        client:{
            get: function(){
                return this.filterByName(FilterTypes.CLIENT)
            },
            set: function(client){
                this.updateFilter({name:FilterTypes.CLIENT, value: client})
            },
        },
    }
}
</script>